import React, { PureComponent } from 'react'
import { Spin, Button, Form, Select, Row, Col, Input, DatePicker, Switch, message, Table,Modal } from 'antd'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { adminList, systemMessageList, appPush,getFeedback,feedbackDetail } from '_src/api/api'
import PrevImg from '_src/components/PrevImg/PrevImg'
import './style.less'

const { Search } = Input
const { TextArea } = Input
const { RangePicker } = DatePicker
const { Option } = Select

@Form.create({ name: '' })
class feedback extends PureComponent {
  constructor () {
    super()
    this.state = {
      isLoading: true,
      params: {
        pageNum: 0,
        pageSize: 10,
      },

      pageData: {
        total: 0,
        current: 1,
      },

      list: [],
      info:{},
      visible:false,

      columns: [
        {
          title: <span>反馈内容</span>,
          align: 'center',
          width:400,
          dataIndex: 'content',
        },
        {
          title: <span>反馈附图</span>,
          align: 'center',
          dataIndex: 'media',
          render: item => item.map((i) => {
            return <img src={i} style={{ width: 100,marginLeft:5,marginTop:5 }} alt='' onClick={() => this.PrevImg.show(i)} />
          })
        },
        {
          title: <span>联系方式</span>,
          align: 'center',
          dataIndex: 'contact',
		},
		{
			title: <span>时间</span>,
			align: 'center',
			dataIndex: 'createAt',
		},
        {
          title: <span>操作</span>,
          align: 'center',
          width: 150,
          render: item => <div>
            <Button type="primary" icon="eye" onClick={() =>this.detail(item.id)}>查看</Button>
          </div>,
        },
      ]

    }
  }
  componentDidMount () {
    adminList().then(res => {
      this.setState({ admins: res.data.content })
    })
    const { params } = this.state
    this.loadList(params)
  }

  loadList (params) {
    this.setState({ isLoading: true })
    getFeedback(params)
      .then(res => {
		  res.data.content.forEach(item => {
			item.media = JSON.parse(item.media)
		  });
        this.setState({
          list: res.data.content,
          isLoading: false,
          pageData: {
            current: res.data.pageable.pageNumber + 1,
			total: res.data.totalElements,
			pageSize: res.data.pageable.pageSize,
		  }
        })
      })
      .catch(err => {
        this.setState({
          list: [],
          isLoading: false,
          pageData: {
            current: 0,
			total: 0,
			pageSize: 0,
		  }
        })
      })
  }

  // 分页
  onPageChange = (e) => {
    const { params } = this.state
    params.pageNum = e.current - 1
    this.loadList(params)
  }


  // 查看详情
  detail = (id) => {
    feedbackDetail(id).then(res =>{
      console.log(res)
      if(res){
        res.data.media = JSON.parse(res.data.media)
        this.setState({
          info:res.data,
          visible:true
        })
      }else{
        message.error('查询失败')
      }
    }).catch(err =>{
      console.log(err)
    })
  }

  deteilModal (info) {
    return (
      <Form className='push-modal-inner' onSubmit={this.handleSubmit} style={{ paddingLeft: 30 }}>
        <Form.Item label="推送人员：" className='flex'>
          <Input value={info.publisher} style={{ width: 300 }} readOnly />
        </Form.Item>
        <Form.Item label="推送时间：" className='flex'>
          <Input value={info.createAt} style={{ width: 300 }} readOnly />
        </Form.Item>
        <Form.Item label="推送标题：" className='flex'>
          <Input value={info.title} style={{ width: 300 }} readOnly />
        </Form.Item>
        <Form.Item label="描述内容：" className='flex'>
          <Input value={info.content} style={{ width: 300 }} readOnly />
        </Form.Item>
        <Form.Item label="是否跳转内容" className='flex'>
          <Switch checked={!!info.parameters} checkedChildren="有详情" unCheckedChildren="无详情" />
        </Form.Item>
        {
          info.keys && (
            <Form.Item label="跳转参数" className='flex'>
              <TextArea value={info.params[info.keys[0]]} style={{ width: 300, height: 80 }} autosize={false} readOnly />
            </Form.Item>
          )
        }
      </Form>
    )
  }

  // 提交创建详情
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const params = {
          title: values.title,
          content: values.content,
        }
        if (values.jump) {
          const pattern = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/
          if (values.type === 'link' && !pattern.test(values.value)) {
            message.error('跳转链接地址不正确')
            return
          }
          params.parameters = {
            [values.type]: values.value
          }
        }
        const hide = message.loading('发布推送中', 0)
        appPush(params)
          .then(res => {
            const _this = this
            const { params } = this.state
            params.pageNum = 0
            _this.setState({ visible: false })
            hide()
            message.success('推送成功！', 1.2, () => {
              _this.loadList(params)
            })
          })
      }
    })
  }

  render () {
    const { admins, isLoading, columns, list, pageData,info ,visible} = this.state
    return (
      <div className="push-page">
		{isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
		<PrevImg ref={el => this.PrevImg = el} />
        {
          !isLoading && (
            <Table
              columns={columns}
              dataSource={list}
              bordered
              rowKey="id"
              pagination={{
                current: pageData.current,
                total: pageData.total,
                pageSize: pageData.pageSize,
              }}
              onChange={this.onPageChange}
            />
          )
        }
        {
          info?<Modal
          title='反馈详情'
          visible={visible || false}
          onCancel={() => {
            this.setState({
              visible: false,
              info: '',
            })
          }}
          width={600}
          footer={false}
          destroyOnClose
        >
          <div className="detail">
          <div className="item">
              <div className="item_left">反馈类型：</div>
              <div className="content">{info.type===1?'产品功能':info.type === 2?'投诉建议':'其它'}</div>
            </div>
            {
              info.content?<div className="item">
              <div className="item_left">反馈内容：</div>
                <div className="content">{info.content}</div>
              </div>
              :null
            }
            <div className="item">
              <div className="item_left">联系方式：</div>
              <div className="content">{info.contact}</div>
            </div>
            {
              info.media && info.media.length>0?<div className="item">
              <div className="item_left">反馈附图：</div>
              <div className="img-box">
              {
                info.media && info.media.map((item) => {
                  console.log(item)
                  return <img src={item} className='img'/>
                })
              }
              </div>
            </div>
            :null
            }
          </div>
        </Modal>
        :null
        }
      </div>
    )
  }
}

export default feedback